import { render } from "./ConsoGroupList.vue?vue&type=template&id=2155f73c&ts=true"
import script from "./ConsoGroupList.vue?vue&type=script&lang=ts"
export * from "./ConsoGroupList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__